import type { Application, SectionSlug } from '../api/types'

// Mirrors apps/api/internal/application/sections.go — the backend rejects
// PATCHes with a current_section outside this set.
interface SectionInfo {
  slug: SectionSlug
  route: string
  step: number
}

export const SECTIONS: SectionInfo[] = [
  { slug: 'welcome', route: '/welcome', step: 0 },
  { slug: 'company_details', route: '/company-details', step: 1 },
  { slug: 'company_structure', route: '/company-structure', step: 2 },
  { slug: 'processing_breakdown', route: '/processing-breakdown', step: 3 },
  { slug: 'review', route: '/review', step: 4 },
]

export function sectionByRoute(route: string): SectionInfo | undefined {
  return SECTIONS.find((s) => s.route === route)
}

export function sectionBySlug(slug: string): SectionInfo | undefined {
  return SECTIONS.find((s) => s.slug === slug)
}

/** Where an authenticated user should land, given their application state.
 *
 *  Only a genuine first-timer (no application at all) is dropped into the
 *  Welcome flow. Anyone with an existing application lands on My Applications:
 *  an unfinished draft is surfaced there with a "Continue" action — rather than
 *  dropping the user cold onto a mid-form step with no reminder — and a user
 *  whose applications are all submitted gets the "Start new application" entry
 *  point. Resuming at the saved section still happens, just on an explicit
 *  Continue click instead of automatically. */
export function resumeRoute(application: Application | null): string {
  if (!application) return '/welcome'
  return '/applications'
}
